// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1cttx","additionalInfo":"AgreementModal_additionalInfo__30q3C"};